import router from 'next/router';
import getPublicEnv from '@utils/getPublicEnv';
import { IDeliveryData, IDeliveryDataMany, IProduct } from '@features/api/platformApiService/typescript';
import fetchNext from '@features/api/fetchNext';
class NextDeliveryApi {
  public endpoints = {
    getDeliveryTime: (productType: string, quantity: number, virtualProductId: number, products: string) => `delivery?productType=${productType}&quantity=${quantity}&virtualProductId=${virtualProductId}&${products}`,
    getDeliveryTimeMany: (products: string) => `delivery?${products}`,
    getDeliveryData: (deliveryId: string) => `delivery/data?deliveryId=${deliveryId}`
  };
  private static getLocale() {
    // TODO: refactor needed when default region is specified
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async getDeliveryTime(deliveryData: IDeliveryData) {
    const {
      json
    } = await fetchNext(this.endpoints.getDeliveryTime(deliveryData.productType, deliveryData.quantity, deliveryData.virtualProductId, this.encodeToDeliveryParams(deliveryData.products)), NextDeliveryApi.getLocale());
    return json;
  }
  public async getDeliveryTimeMany(deliveryData: IDeliveryDataMany) {
    const {
      json
    } = await fetchNext(this.endpoints.getDeliveryTimeMany(this.encodeToDeliveryParamsMany(deliveryData.products)), NextDeliveryApi.getLocale());
    return json;
  }
  public async getDeliveryData(deliveryId: string) {
    const {
      json
    } = await fetchNext(this.endpoints.getDeliveryData(deliveryId), NextDeliveryApi.getLocale());
    return json;
  }
  private encodeToDeliveryParams = (products: IProduct[]): string => {
    let paramString = '';
    products.forEach((product, key) => {
      paramString += `products[${key}][productId]=${product.productId}&products[${key}][quantity]=${product.quantity}`;
      if (key + 1 < products.length) {
        paramString += '&';
      }
    });
    return paramString;
  };
  private encodeToDeliveryParamsMany = (data: IDeliveryData[]): string => {
    let paramString = '';
    data.forEach((deliveryData, key) => {
      paramString += `products[${key}][productType]=${deliveryData.productType}&products[${key}][quantity]=${deliveryData.quantity}&products[${key}][virtualProductId]=${deliveryData.virtualProductId}`;
      deliveryData.products.forEach((product, key2) => {
        paramString += `&products[${key}][products][${key2}][productId]=${product.productId}&products[${key}][products][${key2}][quantity]=${product.quantity}`;
        if (key2 + 1 < deliveryData.products.length) {
          paramString += '&';
        }
      });
      if (key + 1 < data.length) {
        paramString += '&';
      }
    });
    return paramString;
  };
}
export default new NextDeliveryApi();